import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Http, Headers, Response, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

import { AuthService } from './auth.service';

import { environment } from '../../environments/environment';

@Injectable()
export class TransferService {

    apiUrl = environment.apiUrl;

    constructor(private http: Http,
        private authService: AuthService) { }

    getTransfers(parameters): Observable<any> {
        let token = 'Bearer ' + this.authService.getUserToken();
        let accountId = JSON.parse(localStorage.getItem('account') || '{}').id

        let headers = new Headers({ 'Content-Type': 'application/json' });
        headers.append('Authorization', token);
        let params = new URLSearchParams();

        if (parameters.limit) {
            params.set('limit', parameters.limit);
        }
        if (parameters.stmt) {
            params.set('stmt', parameters.stmt);
        }
        if (accountId) {
            params.set('account', accountId);
        }

        return this.http.get(this.apiUrl + '/transfer', { headers: headers, params: params })
            .map(this.extractData)
            .catch(this.handleError);
    }

    getTransfer(transfId): Observable<any> {
        let token = 'Bearer ' + this.authService.getUserToken();

        let headers = new Headers({ 'Content-Type': 'application/json' });
        headers.append('Authorization', token);

        return this.http.get(this.apiUrl + '/transfer/' + transfId, { headers: headers })
            .map(this.extractData)
            .catch(this.handleError);
    }

    createTransfer(transfer): Observable<any> {
        let token = 'Bearer ' + this.authService.getUserToken();

        let headers = new Headers({ 'Content-Type': 'application/json' });
        headers.append('Authorization', token);

        return this.http.put(this.apiUrl + '/transfer', transfer, { headers: headers })
            .map(this.extractData)
            .catch(this.handleError);
    }

    updateTransfer(transfer): Observable<any> {
        let token = 'Bearer ' + this.authService.getUserToken();

        let headers = new Headers({ 'Content-Type': 'application/json' });
        headers.append('Authorization', token);

        return this.http.post(this.apiUrl + '/transfer/' + transfer.id, transfer, { headers: headers })
            .map(this.extractData)
            .catch(this.handleError);
    }

    deleteTransfer(transfer): Observable<any> {
        let token = 'Bearer ' + this.authService.getUserToken();

        let headers = new Headers({ 'Content-Type': 'application/json' });
        headers.append('Authorization', token);

        return this.http.delete(this.apiUrl + '/transfer/' + transfer.id, { headers: headers })
            .map(this.extractData)
            .catch(this.handleError);
    }

    private extractData(res: Response) {
        let body = res.json();
        return body;
    }

    private handleError(error: Response | any) {
        let errMsg: any;
        if (error instanceof Response) {
            errMsg = error.json();
        } else {
            errMsg = error.message ? error.message : error.toString();
        }
        return Observable.throw(errMsg);
    }
}
